(function () {
  var SIZE_PATTERN = /(size|größe|grösse|grosse)/i;
  var ERROR_MESSAGE = "Bitte Größe wählen";
  var REVERT_MS = 2500;

  function isSizeGroup(fs) {
    if (!fs) return false;
    var legend = fs.querySelector("legend, .form__label");
    return !!(legend && SIZE_PATTERN.test(legend.textContent));
  }

  function findSizeGroup() {
    var groups = document.querySelectorAll(
      '[id^="variant-selects-"] fieldset, [id^="variant-selects-"] .product-form__input'
    );
    for (var i = 0; i < groups.length; i++) {
      if (isSizeGroup(groups[i])) return groups[i];
    }
    return null;
  }

  function uncheckSize(group) {
    if (!group) return;
    group.querySelectorAll('input[type="radio"]:checked').forEach(function (r) {
      r.checked = false;
    });
    group.querySelectorAll("label").forEach(function (l) {
      l.classList.remove("active", "is-active", "is-selected", "selected", "checked");
    });
  }

  function getButtonTextEl(btn) {
    return btn.querySelector("span:not(.icon):not(.spinner)") || btn;
  }

  var btnOriginalHtml = null;
  function showError(btn) {
    var textEl = getButtonTextEl(btn);
    if (btnOriginalHtml == null) btnOriginalHtml = textEl.innerHTML;
    textEl.textContent = ERROR_MESSAGE;
    btn.classList.add("onkly-needs-size");
    clearTimeout(btn._revertTimer);
    btn._revertTimer = setTimeout(function () {
      textEl.innerHTML = btnOriginalHtml;
      btn.classList.remove("onkly-needs-size");
    }, REVERT_MS);
  }

  var userPicked = false;

  function safeUncheck() {
    if (userPicked) return;
    var sg = findSizeGroup();
    if (sg) uncheckSize(sg);
  }

  function init() {
    var sizeGroup = findSizeGroup();
    if (!sizeGroup) return;
    var radios = sizeGroup.querySelectorAll('input[type="radio"]');
    if (radios.length <= 1) return;

    // Initial uncheck — 3 retries to outlast Avone's init.
    uncheckSize(sizeGroup);
    setTimeout(safeUncheck, 100);
    setTimeout(safeUncheck, 500);

    // CAPTURE phase click — fires before anything else, marks user pick.
    document.addEventListener("click", function (e) {
      var label = e.target.closest("label");
      if (!label) return;
      var fs = label.closest("fieldset, .product-form__input");
      if (isSizeGroup(fs)) {
        userPicked = true;
      }
    }, true);

    var variantContainer = sizeGroup.closest('[id^="variant-selects-"]');
    if (variantContainer) {
      variantContainer.addEventListener("change", function (e) {
        var input = e.target;
        if (!input || input.tagName !== "INPUT" || input.type !== "radio") return;
        var fs = input.closest("fieldset, .product-form__input");
        if (isSizeGroup(fs)) {
          userPicked = true;
        }
      }, false);

      // Observer on a stable parent that contains variant-selects but NOT
      // media-gallery. variant-selects itself can be entirely replaced by
      // Avone (orphaning an observer attached to it), so we go one level up.
      var observerRoot = document.querySelector("product-form") ||
                         variantContainer.parentNode ||
                         variantContainer;
      var observer = new MutationObserver(function () {
        if (userPicked) return;
        // Synchronous — runs before browser paints, so Avone's active-marking
        // never reaches the screen. No blink.
        safeUncheck();
      });
      observer.observe(observerRoot, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ["class", "checked"]
      });
    }

    // Add-to-cart click guard.
    document.addEventListener("click", function (e) {
      var clicked = e.target.closest(
        '[name="add"], button.product-form__submit, button[type="submit"], button.btn-product-add'
      );
      if (!clicked) return;
      var form = clicked.closest("form");
      if (!form || !form.matches('form[action*="/cart/add"], product-form form')) return;

      if (!userPicked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        showError(clicked);
      }
    }, true);

    // Form submit guard.
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form.matches('form[action*="/cart/add"], product-form form')) return;
      if (!userPicked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        var btn = form.querySelector('[name="add"], button[type="submit"]');
        if (btn) showError(btn);
      }
    }, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
